<template>
    <div class="video-participant" :class="{'talking':isTalking}">
        <div class="aspect-ratio-spacer">
            <div class="video-wrapper">
                <video v-show="isReady" :ref="'remoteVideo' + uid" autoplay webkit-playsinline playsinline></video>
                <!--<div v-show="isReady" class="video-participant-displayname">{{displayname}}</div>-->
                <div v-show="!isReady" class="getting-ready">User not connected...</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:"VideoParticipant",
        props:['uid', 'displayname', 'stream', 'hasVideo','isReady'],
        data () {
            return {
                audioContext:null,
                streamSource:null,
                meter:null,
                rafID:null,
                rafID2:null,
                level:null,
                isTalking:false,
                talkLevel:0.03
            }
        },
        methods: {
            setLevel: function () {
                this.level = this.meter.volume;
                if(this.level >= this.talkLevel) {
                    clearTimeout(this.rafID2);
                    this.isTalking = true;
                    this.rafID2 = setTimeout(() => {
                        this.isTalking = false;
                    }, 2000);
                }
                this.rafID = window.requestAnimationFrame(this.setLevel);
            }
        },
        beforeDestroy: function() {
            if(this.meter) {
                this.meter.shutdown();
            }
        },
        mounted () {
            if(this.stream) {
                let audio = this.stream.getTracks().find(track => track.kind === 'audio');

                if(audio) {
                    this.audioContext = new AudioContext();
                    this.streamSource = this.audioContext.createMediaStreamSource(this.stream);
                    this.meter = this.$volumeMeter(this.audioContext);
                    this.streamSource.connect(this.meter);
                    this.setLevel();
                }
                this.$janus.attachMediaStream(this.$refs['remoteVideo' + this.uid], this.stream)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/VideoParticipant.vue